function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Svg, { G, Path } from 'react-native-svg';
import { memo } from 'react';
const PlusOutline = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: 28,
  height: 28
}, props), /*#__PURE__*/React.createElement(G, {
  stroke: "#FFF",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M13.5 25c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z"
}), /*#__PURE__*/React.createElement(Path, {
  d: "m13.64 12.815-5.996.046 5.994-.048V7.075v5.738l5.89-.046-5.89.046v6.042z"
})));
const PlusOutlineIcon = /*#__PURE__*/memo(PlusOutline);
export default PlusOutlineIcon;
//# sourceMappingURL=index.js.map